const breadCrumb = "Lotação de Servidores - Manutenção de Informações Servidor";

const routes = [
  {
    path: "/resposta-da-solicitacao-de-remocao-do-servidor",
    name: "resposta-da-solicitacao-de-remocao-do-servidor",
    meta: {
      requireAuth: false,
      // allowedPermissions: ["parametro_periodo_remocao_list"],
      breadCrumb: breadCrumb,
    },
    component: () =>
      import(
        "@/views/ManutencaoDeInformacoesDoServidor/RemocaoDoServidor/RespostaDaSolicitacaoDeRemocaoDoServidor/RespostaDaSolicitacaoDeRemocaoDoServidorHome.vue"
      ),
  },
  {
    path: "/resposta-da-solicitacao-de-remocao-do-servidor/responder/:id",
    name: "resposta-da-solicitacao-de-remocao-do-servidor-responder",
    meta: {
      requireAuth: false,
      // allowedPermissions: ["parametro_periodo_remocao_insert"],
      breadCrumb: breadCrumb,
    },
    component: () =>
      import(
        "@/views/ManutencaoDeInformacoesDoServidor/RemocaoDoServidor/RespostaDaSolicitacaoDeRemocaoDoServidor/RespostaDaSolicitacaoDeRemocaoDoServidorResponder.vue"
      ),
  },
  {
    path: "/resposta-da-solicitacao-de-remocao-do-servidor/consultar/:id",
    name: "resposta-da-solicitacao-de-remocao-do-servidor-consultar",
    meta: {
      requireAuth: false,
      // allowedPermissions: ["parametro_periodo_remocao_update"],
      breadCrumb: breadCrumb,
    },
    component: () =>
      import(
        "@/views/ManutencaoDeInformacoesDoServidor/RemocaoDoServidor/RespostaDaSolicitacaoDeRemocaoDoServidor/RespostaDaSolicitacaoDeRemocaoDoServidorConsultar.vue"
      ),
  },
];

export default routes;
